module.exports = __webpack_public_path__ + "assets/notebook.f869ecfc4ea313dabdb1218e1f700d55.svg";